<app-page-wrapper>
  <div class="title-wrapper">
    <h1 class="title" translate>VIRTUAL_TOKEN_PAGE.TITLE</h1>
    <button
      (click)="openModal('TOKEN_FORM')"
      type="button"
      class="ic1-btn ic1-btn-sm ic1-btn-secondary generate-button">
      <div translate>VIRTUAL_TOKEN_PAGE.GENERATE_NEW_TOKEN</div>
      <img src="assets/images/generate-icon.svg" />
    </button>
  </div>

  <div class="ic1-my-12">
    <ng-ui-kit-toast
      *ngIf="showSuccess"
      status="success"
      [text]="
        'VIRTUAL_TOKEN_PAGE.' + successMode + '_SUCCESS'
          | translate: { name: tokenName }
      "
      (click)="showSuccess = false">
    </ng-ui-kit-toast>
  </div>

  <div class="order-wrapper" *ngIf="tokens.length > 0" translate>
    ACTION_REPORT_PAGE.ORDER_BY
    <div (click)="orderTokens()" class="order">
      <span *ngIf="reversed" translate
        >VIRTUAL_TOKEN_PAGE.MOST_RECENT_TOKEN</span
      >
      <span *ngIf="!reversed" translate>VIRTUAL_TOKEN_PAGE.MOST_OLD_TOKEN</span>
      <img
        src="assets/images/arrow-down.svg"
        [ngClass]="{ reversed: reversed }" />
    </div>
  </div>

  <div class="card" *ngFor="let token of paginatedTokens">
    <div class="card-wrapper">
      <div class="left">
        <div class="card-title">{{ token.name }}</div>
        <div class="under-card-title" *ngIf="token.status === 'VALID'">
          <div
            class="expiring-date"
            [innerHTML]="
              'VIRTUAL_TOKEN_PAGE.VALID_UNTIL'
                | translate
                  : {
                      startDate: formatTokenDate(token.createdAt),
                      endDate: formatTokenDate(token.expirationDate),
                    }
            "></div>
          <span *ngIf="!isTrissUser"> | </span>
          <div
            *ngIf="token.signatures && token.signatures >= 0 && !isTrissUser"
            class="signs"
            [innerHTML]="
              'VIRTUAL_TOKEN_PAGE.USED_SIGN'
                | translate
                  : {
                      usedSigns: token.remainingSignatures,
                      totalSigns: token.signatures,
                    }
            "></div>
          <div
            class="signs"
            *ngIf="!token.signatures || token.signatures < 0"
            translate>
            VIRTUAL_TOKEN_PAGE.UNLIMITED_SIGNS
          </div>
        </div>
        <div class="under-card-title" *ngIf="token.status === 'REVOKED'">
          <div class="expiring-date" translate>
            VIRTUAL_TOKEN_PAGE.TOKEN_REVOKED
          </div>
        </div>
      </div>
      <div class="actions">
        <a
          class="revoke"
          *ngIf="token.status === 'VALID'"
          (click)="openModal('REVOKE', token.id, token.name)"
          translate="CERT_PAGE.REVOKE"
          ><img src="assets/images/revoke-icon.svg"
        /></a>
        <span *ngIf="token.status === 'VALID'"> | </span>
        <a
          class="download"
          (click)="openModal('DOWNLOAD', token.id)"
          translate="CERT_PAGE.DOWNLOAD"
          ><img src="assets/images/download-token-icon.svg"
        /></a>
      </div>
    </div>
  </div>

  <div
    class="ic1-flex ic1-items-center ic1-justify-center"
    *ngIf="totalItems > itemsPerPage">
    <!-- <ng-ui-kit-select
        class="ic1-hide-xs ic1-mr-12"
        [options]="options"
        (onChange)="onChangeItemsPerPage($event)"></ng-ui-kit-select> -->

    <ng-ui-kit-paginator
      [items]="totalItems"
      size="sm"
      (onPageChange)="onPageChanged($event)"
      [itemsPerPage]="itemsPerPage">
    </ng-ui-kit-paginator>
  </div>
</app-page-wrapper>

<app-common-modal
  modalId="otp-modal"
  [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
  [(visible)]="otpModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleOtpModal(false)">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="desc" translate>COMMON.ACCORDION_OTP.DESC</div>
    <div class="ic1-form-group">
      <app-otp-input
        formControlName="otp"
        [startTimer]="otpModalVisible"></app-otp-input>
    </div>
    <div class="buttons-container">
      <ng-ui-kit-button
        color="secondary"
        [label]="'COMMON.BUTTON.CANCEL' | translate"
        type="button"
        size="sm"
        (onClick)="closeModal()">
      </ng-ui-kit-button>
      <app-submit-button
        type="submit"
        [loading]="loading"
        [label]="'COMMON.BUTTON.CONFIRM' | translate"
        translate-key="COMMON.BUTTON.CONFIRM"
        [disabled]="!form.valid">
      </app-submit-button>
    </div>
  </form>
</app-common-modal>

<app-common-modal
  modalId="token-form-modal"
  [title]="'VIRTUAL_TOKEN_PAGE.GENERATE_NEW_TOKEN' | translate"
  [(visible)]="tokenFormModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onToggleTokenFormModal(false)">
  <app-virtual-token-form
    (closeModalEvent)="onToggleTokenFormModal(false)"></app-virtual-token-form>
</app-common-modal>
